import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { ApiService } from "./api.service";
import { Category } from "../model/claim/category";
import { ICategory } from "../model/teal_health/procedure";
import { TypicalBillInRange } from "../model/teal_health/typical-bill";
import { from, lastValueFrom, zip } from "rxjs";
import { LocationResult, TealPracticeResult } from "../model/claim/procedure_lookup_result";
import { Location } from "../model/provider/location";
import { Practice } from "../model/provider/practice";

@Injectable({
  providedIn: 'root'
})
export class TealHealthService 
{
    constructor(private apiService: ApiService) {}
    
    async tealLookupByZipRadius(zipCode: string, radius: number, category: ICategory, procCodes?: string[]) : Promise<TealPracticeResult[]>
    {

        //Teal Health returs TypicalBill Results from its endpoint 
        const typicalResults = await lastValueFrom(from(this.apiService.makeAPIGetCall<TypicalBillInRange[]>(
        environment.thAPIBase,
        "/medical/bills/typical/",
        {
            ... zipCode && {zip: zipCode},
            ... radius && {radius: radius.toString()},
            ... category && { categoryId: category.id.toString() },
            ... procCodes && { procCodeFilter: procCodes }
        }
        )));

        //Convert TypicalBill results to TealPracticeResult
        const tealResults : TealPracticeResult[] = typicalResults.map
        (
            tp => 

            {
                var tpr = new TealPracticeResult();
                tpr.locations = tp.practiceLocations.map
                (
                    l => 
                    { 
                        var lr = new LocationResult(); 
                        lr.location = new Location();
                        lr.location.street1 = l.street1;
                        lr.location.street2 = l.street2 ?? '';
                        lr.location.city = l.city;
                        lr.location.state = l.state;
                        lr.location.zip = l.zipCode;
                        lr.location.lat = l.latitude.toString();
                        lr.location.lon = l.longitude.toString();
                        lr.distance = { length: l.distanceInMiles,units : 'mi',drivingDistance: l.distanceInMiles };
                        lr.location.locationGeocodeId = l.id;
                        lr.location.locationId = l.id;
                        lr.location.conversionLocation = false;
                        tpr.tier = 0;
                        return lr;
                    }
                    
                );

                tpr.practiceCost = tp.typicalPaidToProvider;
                tpr.practiceName = tp.practice.name + (tp.note ? ' - (' + tp.note + ')' : '');
                tpr.practice = new Practice();
                tpr.practice.ein = tp.practice.ein;
                tpr.practice.conversionPractice = false;
                tpr.practice.practiceName = tp.practice.name;
                
                return tpr;
            }
        );

        return tealResults;
    }


    GetMe()
    {
        return this.apiService.makeAPIGetCall<any>
        (
            environment.thAPIBase,
            "/util/user/me",
            {}
        );
    }

    async CreateEncounterAssignedDiary
    (
        encounterId: number,
        assignedByName: string,
        assignedToId: number,
        phiId: number,
    )
    {
        await this.AddEncounterToParty(encounterId, phiId);

        const di = new TealHealthEncounterAssignedDiaryInsert(assignedToId, assignedByName);

        return this.apiService.makeAPIPutCall<any>
        (
            environment.thAPIBase,
            "/encounters/" + encounterId + "/diary/encounterassigned",
            di,
            {}
        );
    }

    AddEncounterToParty
    (
        encounterId: number,
        phiId: number,
    )
    {
        return this.apiService.makeAPIPutCall<any>
        (
            environment.thAPIBase
            ,"/encounters/" + encounterId + "/party/" + phiId
            ,''
            ,{}
        );
    }

}

export class TealHealthEncounterAssignedDiaryInsert
{
    constructor
    (
        public assignedToId: number,
        public assigningUserName: string
    )
    {

    }

}